var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3516 29.2969L25 50L39.6484 29.2969L25 37.832L10.3516 29.2969ZM39.6875 22.4023L25 0L10.3125 22.4023L25 16.1914L39.6875 22.4023Z",
    fill: "#8CBD9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2344 25.6836L25 19.2383L9.76562 25.6836L25 34.2187L40.2344 25.6836Z",
    fill: "#8CBD9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg23);
export default __webpack_public_path__ + "static/media/23.e8e4a567222c58f131822a61bdda521f.svg";
export { ForwardRef as ReactComponent };